import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

/**
 * Wrap admin-only pages. Renders children only if the caller is
 * authenticated AND is_admin. Non-admins are sent home (server also
 * enforces via require_admin — this is UX-only).
 */
export default function RequireAdmin({ children }) {
  const auth = useAuth();
  if (auth.loading) {
    return (
      <div
        data-testid="admin-loading"
        className="mx-auto w-full max-w-[1000px] px-5 py-16 text-body text-ink-muted"
      >
        Checking access…
      </div>
    );
  }
  if (!auth.user || !auth.user.is_admin) {
    return <Navigate to="/" replace />;
  }
  return children;
}
